import React from 'react';

import wrapStore from '@src/utils/wrap-store';
import AppointmentModalStore from './store';
import ModalContainer from '@src/components/modal-container';
import cx from 'classnames';
import Input from '../components/input';
import getPageLocalesData, { getLocalesForHtml } from '@src/global-locales/get-page-locales-data';
import EmailCodeInput from '@src/components/email-code-input';
import { PROTOCOL } from '@src/utils/locale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { getLocales } from '@src/global-locales/get-page-locales-data';

const pageLocalesData = getPageLocalesData();
const reserveLocalesData = pageLocalesData.reserve;
const styles = require('./index.less');

/**
 * 预约弹窗
 * @param store {AppointmentModalStore}
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const AppointmentModal = ({ store, onClose }) => {
  store.use();
  store.onClose = onClose;
  /**
   * 渲染预约类型
   * @returns {unknown[]}
   */
  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.root}>
        <div className="appointment-modal-root">
          <div className={styles.closeBtn} onClick={store.onCloseHandler} />
          {/* {renderSuccess()} */}
          <div className="appointment-modal-group-1" data-name="预约弹窗">
            <div className={styles.successModal}>
              <div className="appointment-modal-layer-2" data-name="切换tab ">
                {/*{renderAppointmentTypeRadio()}*/}
              </div>
              <div className="appointment-modal-group-2" data-name="输入框">
                <div className="appointment-modal-layer-3" data-name="邮箱">
                  <Input placeholder={reserveLocalesData.form.email} store={store.inputStores.emailInput} />
                </div>
                <div className="appointment-modal-group-3" data-name="验证码">
                  <Input placeholder={reserveLocalesData.form.vcode} store={store.inputStores.smsInput} />
                  <div className={cx(styles.smsBtnBox, store.inputStores.smsInput.isError ? styles.hideSmsBtn : styles.showSmsBtn)}>
                    <EmailCodeInput
                      codeBtnClassName={styles.codeBtn}
                      buttonText={reserveLocalesData.form.get_code}
                      sendCode={store.onSendVCRequest}
                      validator={store.emailInputValidator}
                    />
                  </div>
                </div>
              </div>

              <div className="appointment-modal-group-4" data-name="登录按钮">
                <div className="appointment-modal-group-5" data-name="组 1">
                  <div className="appointment-modal-layer-9" data-name="立即预约" onClick={store.onSubmit} />
                  {store.isGiftOpen ? pageLocalesData.reserve.button2 : pageLocalesData.reserve.button}
                </div>
              </div>

              <div className="appointment-modal-group-6" data-name="协议">
                <div
                  className={cx('appointment-modal-layer-13', store.protocolShaking && styles.shaking)}
                  data-name="未注册的手机验证后将自动登录。注册/登录即代表您同意并遵守《西山居用户服务协议》《西山居用户个人用户信息及隐私保护政策》 "
                >
                  <div
                    className={cx('appointment-modal-layer-14', store.isAgreementProtocol && 'hasAgreed')}
                    data-name="单选框"
                    onClick={store.onAgreeProtocolChange}
                  />
                  <div className="appointment-modal-layer-text">
                    {getLocalesForHtml('reserve.agreement.desc', {
                      arg1: getLocales('reserve.agreement.agreement1'),
                      arg1Link: PROTOCOL[getLanguageByPath()].appointment
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(AppointmentModal, AppointmentModalStore);
